export default __webpack_public_path__ + "static/media/csacademy.bfbd4137.png";